import { render, staticRenderFns } from "./EmailAttachmentsBottom.vue?vue&type=template&id=d5d7210a"
import script from "./EmailAttachmentsBottom.vue?vue&type=script&lang=js"
export * from "./EmailAttachmentsBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports